import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNextStepAfterUpdate } from '../Wizard/Wizard.hooks';
import SelectionComponent from './SelectionComponent';

export interface PianoStyleProps {}

const PianoStyle: React.FC<PianoStyleProps> = ({}) => {
  const { t } = useTranslation();
  const next = useNextStepAfterUpdate();
  const handleClick = (style: 'classic' | 'pop') => {
    next({ style: style ?? 'pop' }, 'piano');
  };

  const answers = [
    { title: t('home.input.dialog.style_piano.classical'), key: 'classic' },
    { title: t('home.input.dialog.style_piano.pop'), key: 'pop' },
    { title: t('home.input.dialog.unknown'), key: null },
  ];
  return <SelectionComponent answers={answers} handleClick={handleClick} id="style_piano" />;
};

export default PianoStyle;
